// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodEquipmentParameterId = (z.number());
export const foodEquipmentParameter = z.object({
    id: foodEquipmentParameterId,
    name: z.string(),
    unit: z.string().nullable(),
    deleted_at: z.date().nullable(),
    created_at: z.date(),
    deleted_by: operatorId.nullable(),
});
export const foodEquipmentParameterInitializer = z.object({
    id: foodEquipmentParameterId.optional(),
    name: z.string(),
    unit: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodEquipmentParameterMutator = z.object({
    id: foodEquipmentParameterId.optional(),
    name: z.string().optional(),
    unit: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodEquipmentParameter.js.map